import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, TextField, InputAdornment, IconButton, Fab, Tooltip } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import MaterialTable from 'material-table';

const styles = (theme) => ({
    section: {
        marginTop: theme.spacing(3),
    },
    subSection: {
        background: grey[100],
        padding: theme.spacing(3),
    },
    choice: {
        margin: theme.spacing(1),
    },
    choiceBox: {
        maxWidth: 500,
    },
    addButton: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    fab: {
        margin: theme.spacing(1),
    },
    flexRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    larger: {
        width: '85%',
    },
});

class QuestionContent extends React.Component {
    handleChangeStep = (event) => {
        this.props.onChange(event.target.name, event.target.value);
    };

    handleChangeChoice = (index, newChoice) => {
        const choice = { choice: newChoice };
        this.props.onChoicesUpdate(index, choice);
    };

    handleAddChoice = () => {
        const index = this.props.step.choices.length;
        const newChoice = { choice: `Choice ${index + 1}` };
        this.props.onChoicesUpdate(index, newChoice);
    };

    handleDeleteChoice = (index) => {
        this.props.onChoicesUpdate(index);
    };

    render() {
        const choices = this.props.step.choices ? this.props.step.choices : [];

        const stepsLookup = Object.assign(
            {},
            this.props.steps
                .map((step, index) => `Step ${index + 1}`)
                .filter((step, index) => index !== this.props.steps.indexOf(this.props.currStep)),
        );

        return (
            <React.Fragment>
                {
                    <div className={this.props.classes.section}>
                        <Typography variant="body1" color="primary">
                            Question Text
                        </Typography>
                        <div className={this.props.classes.subSection}>
                            <TextField
                                name="text"
                                label="Text"
                                value={this.props.step.text}
                                margin="dense"
                                multiline
                                fullWidth
                                onChange={this.handleChangeStep}
                            />
                        </div>
                    </div>
                }
                <div className={this.props.classes.section}>
                    <Typography variant="body1" color="primary">
                        Choices
                    </Typography>
                    <div className={this.props.classes.subSection}>
                        <div className={this.props.classes.flexRow}>
                            <div className={this.props.classes.larger}>
                                {choices.map((choice, index) => (
                                    <div className={this.props.classes.choice} key={index}>
                                        <TextField
                                            className={this.props.classes.choiceBox}
                                            fullWidth
                                            variant="outlined"
                                            value={choice.choice}
                                            onChange={(event) => this.handleChangeChoice(index, event.target.value)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => this.handleDeleteChoice(index)}>
                                                            <DeleteIcon color="disabled" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div className={this.props.classes.addButton}>
                                <Tooltip title="Add Choice">
                                    <Fab
                                        color="primary"
                                        onClick={this.handleAddChoice}
                                        size="small"
                                        className={this.props.classes.fab}
                                    >
                                        <AddIcon />
                                    </Fab>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={this.props.classes.section}>
                    <Typography variant="body1" color="primary">
                        Next Steps
                    </Typography>
                    <div className={this.props.classes.subSection}>
                        <Typography variant="body2">Set the next step for each answer choice:</Typography>
                        <MaterialTable
                            title="Disable Field Editable Preview"
                            columns={[
                                { title: 'Answer', field: 'choice', editable: 'never' },
                                { title: 'Continue With', field: 'step', editable: 'onUpdate', lookup: stepsLookup },
                            ]}
                            components={{
                                Container: ({ children }) => <div className={this.props.classes.table}>{children}</div>,
                            }}
                            data={this.props.data}
                            options={{
                                toolbar: false,
                                paging: false,
                            }}
                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            {
                                                const nextSteps = [...this.props.data];
                                                const index = nextSteps.indexOf(oldData);
                                                nextSteps[index] = newData;
                                                this.props.onNextStepsChange(nextSteps);
                                            }
                                            resolve();
                                        }, 1000);
                                    }),
                            }}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(QuestionContent);
